import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import PropTypes from 'prop-types';

import {PERIOD_TYPES, PERIOD_TYPES_ARR} from 'config/constants/period';

import MonthDropdown from 'components/ui/form/dates/month/MonthDropdown';
import DateTimeDropdown from 'components/ui/form/dates/datetime/DateTimeDropdown';
import SpogDropdown from 'components/ui/form/SpogDropdown';

import {getNow} from 'util/utils';

import 'style/components/period/period-dropdown.scss';

/* This component shows a Period component */
export class PeriodDropdown extends Component {

    static propTypes = {
        value:         PropTypes.number, // The selected date for the dropdown on route
        dropdownItems: PropTypes.array, // The array with the items to show in the dropdown for types
        type:          PropTypes.string, // The date type for the dropdown on route
        onChange:      PropTypes.func.isRequired, // Listener when the date has been selected
        onChangeType:  PropTypes.func.isRequired // Listener when the type has been changed
    };

    static defaultProps = {
        type:          PERIOD_TYPES.PERIOD_TYPE_MONTH,
        dropdownItems: PERIOD_TYPES_ARR
    };

    state = {
        dropdownItems: []
    };

    componentWillMount() {
        const {dropdownItems, intl:{formatMessage}} = this.props;

        this.setState({
            dropdownItems: dropdownItems.map(item => ({
                id:   item,
                text: formatMessage({id: `label.dropdown.type.${item}`})
            }))
        });
    }

    componentWillReceiveProps(nextProps) {
        const {dropdownItems, intl} = this.props;
        const {intl: {formatMessage}} = nextProps;

        if (nextProps.dropdownItems !== dropdownItems ||
            nextProps.intl !== intl) {
            this.setState({
                dropdownItems: nextProps.dropdownItems.map(item => ({
                    id:   item,
                    text: formatMessage({id: `label.dropdown.type.${item}`})
                }))
            });
        }
    }

    renderDate() {
        const {value, onChange} = this.props;

        const _value = value instanceof Date ? value : new Date(value);

        return (
            <DateTimeDropdown
                value={_value}
                onChange={onChange}
                endLimit={getNow()}
                hideTime
                notClean
            />
        );
    }

    renderMonth() {
        const {value, onChange} = this.props;

        return (
            <MonthDropdown
                selectedDay={value}
                onChange={onChange}
            />
        );
    }

    renderPicker() {
        const {type} = this.props;

        switch (type) {
        case PERIOD_TYPES.PERIOD_TYPE_MONTH:
            return this.renderMonth();
        case PERIOD_TYPES.PERIOD_TYPE_DATE:
            return this.renderDate();
        }

        return null;
    }

    renderDropdown() {
        const {type, onChangeType} = this.props;
        const {dropdownItems} = this.state;
        const MIN_ITEMS_DROPDOWN = 1;


        return dropdownItems.length > MIN_ITEMS_DROPDOWN ? (
            <SpogDropdown
                id="period-dropdown"
                items={dropdownItems}
                value={type}
                onChange={onChangeType}
            />
        ) : null;
    }

    render() {
        return (
            <div className="period-dropdown">
                {this.renderDropdown()}
                {this.renderPicker()}
            </div>
        );
    }
}

export default injectIntl(PeriodDropdown);



// WEBPACK FOOTER //
// ./src/components/period/PeriodDropdown.jsx